// initial state
const state = () => ({
    entities: {
        step1EntityData: null,
        step2AdmAccount: null,
        step3Modules: null,
        currentStep: 1,
        allStepsData: null,
    }
})

// getters
const getters = {
    getEntitiesState(state) {
        return state;
    },
    getCurrentStep(state) {
        return state.entities.currentStep;
    },
    getEntityStep1(state) {
        return state.entities.step1EntityData;
    },
    getEntityStep2(state) {
        return state.entities.step2AdmAccount;
    },
    getEntityStep3(state) {
        return state.entities.step3Modules;
    },
}

// actions
const actions = {
}

// mutations
const mutations = {
    setEntitiesState(state, payload)
    {
        for (var [key, value] of Object.entries(payload)) {
            state[key] = value;
        }
    },
    setCurrentStep(state, payload) {
        state.entities.currentStep = payload;
    },
    setEntityStep1(state, payload) {
        state.entities.step1EntityData = payload;
    },
    setEntityStep2(state, payload) {
        state.entities.step2AdmAccount = payload;
    },
    setEntityStep3(state, payload) {
        state.entities.step3Modules = payload;
    }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
